import React, { Component } from 'react';
import { Card, CardImg, CardImgOverlay,
    CardTitle, CardBody, CardText, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from './LoadingComponent';

function RenderComboItem ({combo}) {
    return (
        <Card>
           <Link to={`/combos/${combo.id}`} >
            {<CardBody>
                <CardTitle>{combo.name}</CardTitle>
             </CardBody>}
           </Link>
        </Card>
    );
}

const Combos = (props) => {

    const combo = props.combos.map((combo) => {
        return (
            <div className="col-12 col-md-5 m-1"  key={combo.id}>
                <RenderComboItem combo={combo} onClick={props.onClick}/>
            </div>
        );
    });


return (
    <div className="container">
        <div className="row">
            <Breadcrumb>
                <BreadcrumbItem><Link to="/home">Home</Link></BreadcrumbItem>
                <BreadcrumbItem active>Combos</BreadcrumbItem>
            </Breadcrumb>
            <div className="col-12">
                <p>The positions start easy but then get harder. Many more to come!</p>
                <p>Click on a game to solve a Fischer combo.</p>
                <hr />
            </div>
        </div>
        <div className="row">
            {combo}
        </div>
    </div>
);
}


export default Combos;
